import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    workspaceUuid: { type: String, default: "" },
    profileSlug: { type: String, default: "" },
    savedResources: { type: Boolean, default: false },
    loadCapacity: { type: Boolean, default: false }
  }

  connect() {
    this.setActiveWorkspace();
    if (this.loadCapacityValue) PowerBi.getAvailableEmbedTokenCapacity();
  }

  setActiveWorkspace() {
    if (this.savedResourcesValue) {
      $(".workspace-list-item").removeClass("active");
      $("#available-report-list > .list-group-item").addClass("active");
    } else if (this.workspaceUuidValue) {
      $(".workspace-list-item.list-group-item").removeClass("active");
      $(`.workspace-list-item[data-workspace-uuid='${this.workspaceUuidValue}']`).addClass("active");
    }
  }

  loadWorkspace(e) {
    e.preventDefault();
    $("#available-report-list > .list-group-item").removeClass("active");
    const { workspaceUuid, workspaceName } = e.currentTarget.dataset;
    if (!workspaceUuid) throw new Error("No Workspace UUID found for that workspace");
    if (!workspaceName) throw new Error("No Workspace Name found for that workspace");
    PowerBi.loadResources(this.profileSlugValue, workspaceUuid, workspaceName);
  }

  saveDashboard(e) {
    e.preventDefault();
    const { workspaceUuid, dashboardUuid, dashboardName } = e.currentTarget.dataset;
    PowerBi.openCreateDashboardModal(this.profileSlugValue, workspaceUuid, dashboardUuid, dashboardName);
  }

  revokeDashboard(e) {
    e.preventDefault();
    PowerBi.performRevokeDashboardFlow(e);
  }

  saveReport(e) {
    e.preventDefault();
    const { workspaceUuid, reportUuid, reportName } = e.currentTarget.dataset;
    PowerBi.openCreateReportModal(this.profileSlugValue, workspaceUuid, reportUuid, reportName);
  }

  revokeReport(e) {
    e.preventDefault();
    PowerBi.performRevokeReportFlow(e);
  }

  revokeAvailableReport(e) {
    e.preventDefault();
    PowerBi.performRevokeSavedReportFlow(e);
  }

  revokeSavedDashboard(e) {
    e.preventDefault();
    PowerBi.performRevokeSavedDashboardFlow(e);
  }
}
